import * as React from "react";
import {MainStageEvent} from "data/MainStageData";
import * as moment from 'moment-timezone';

import './MainStageEventScheduleItem.pcss';
import {NavAvatar} from "components/nav/NavAvatar";


// @ts-ignore
/**
 *
 *
 * @param props
 * @constructor
 */
export const MainStageEventScheduleItem = (props:{event:MainStageEvent}) =>
  <div className={"mainstage-schedule-item"} role={'listitem'} aria-label={`${props.event.title}, ${moment(props.event.presentationStartTS).tz(moment.tz.guess()).format('MMMM Do [at] h:mm A zz')}`}>
    <div className={"strv_row"}>
      <div
        className={"session-info strv_col"}
        aria-label={`${props.event.title}, ${moment(props.event.presentationStartTS).tz(moment.tz.guess()).format('MMMM Do [at] h:mm A zz')}`}
        role="heading"
        aria-level={3}
      >
        <span aria-hidden={true}>
          <strong>{moment(props.event.presentationStartTS).tz(moment.tz.guess()).format('M/D [at] h:mm A')}</strong>
          {moment(props.event.presentationStartTS).tz(moment.tz.guess()).format('z')}
          <br/>
          <span className={"title"}>{props.event.title}</span>
        </span>
      </div>
      <div className={"pwn-presenter strv_col"}>
        <NavAvatar user={props.event.presenter} variant={'large'} style={{marginRight: '8px'}} />
        <div className={"name_title"}>
          <span className={"name"}><span className={"visuallyhidden"}>Presented by </span>{props.event.presenter.firstName} {props.event.presenter.lastName}</span>
          {props.event.presenter.professionalTitle}
        </div>
      </div>
    </div>
    <div className={"session-details"}>
      <div className={"title"}>
        <span className={"date"}>{moment(props.event.presentationStartTS).tz(moment.tz.guess()).format('h:mm')}&ndash;{moment(props.event.presentationEndTS).tz(moment.tz.guess()).format('h:mm')}</span>
        &nbsp;
        <span className={"desc"}>Live Session</span>
        &nbsp;
        •
        &nbsp;
        <span className={"date"}>{moment(props.event.qaStartTS).tz(moment.tz.guess()).format('h:mm')}&ndash;{moment(props.event.qaEndTS).tz(moment.tz.guess()).format('h:mm')}</span>
        &nbsp;
        <span className={"desc"}>Live Q & A</span>
      </div>
      {props.event.description && <div dangerouslySetInnerHTML={{__html:props.event.description}} /> }
    </div>
  </div>
;
